import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import MapContainer from '../../../Components/Common/MapContainer';
import { isValidURL } from '../utils';

/**
 * Restaurant location component displaying map and contact information
 * @param {Object} props - Component props
 * @param {Object} props.data - Restaurant data
 */
const RestaurantLocation = ({ data }) => {
  if (!data) return null;

  return (
    <>
      {/* Map Display */}
      <Box sx={{ mt: 3, height: '300px', overflow: 'hidden' }}>
        <MapContainer
          variant="map"
          restaurantAddress={data?.Address}
        />
      </Box>

      {/* Contact Information */}
      <Box
        sx={{
          p: 3,
          boxSizing: 'border-box',
          border: '1px solid #d7d7d7',
        }}
      >
        <Typography sx={{ fontSize: '18px', fontWeight: 500 }}>
          Locate {data?.RestaurantName}
        </Typography>

        <Typography sx={{ mt: 0.5, fontSize: '12px' }}>
          {data?.Address}
        </Typography>

        <Box sx={{ mt: 3 }}>
          {/* Phone Number */}
          {data?.PhoneNumaber && (
            <a href={`tel:+234${data?.PhoneNumaber}`}>
              <Typography color="primary">
                +234 {data?.PhoneNumaber}
              </Typography>
            </a>
          )}

          {/* Map Button */}
          <Box sx={{ mt: 2 }}>
            <MapContainer
              variant="button"
              restaurantAddress={data?.Address}
            />
          </Box>

          {/* Website Link */}
          {isValidURL(data?.Restaurantwebsite) && (
            <Box sx={{ mt: 2 }}>
              <a href={data?.Restaurantwebsite} target="_blank" rel="noopener noreferrer">
                <Typography color="primary">
                  Restaurant Website
                </Typography>
              </a>
            </Box>
          )}

          {/* Email Address */}
          {data?.EmailAddress && (
            <Box sx={{ mt: 2 }}>
              <a href={`mailto:${data?.EmailAddress}`}>
                <Typography color="primary">
                  {data?.EmailAddress}
                </Typography>
              </a>
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};

RestaurantLocation.propTypes = {
  data: PropTypes.object,
};

export default RestaurantLocation;
